// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c3436501","806":"19f0144f","893":"0b2b193d"}[chunkId] + ".chunk.js";
};